import React from 'react';

class SMFormSelectBox extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: this.props.name,
      value : this.props.selectedValue,
      isRequired: this.props.isRequired,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      name: nextProps.name,
      value : nextProps.selectedValue,
    });
  }

  didChangeValue(e) {
    this.setState({value: e.currentTarget.value});
    if(this.props.delegate && typeof this.props.delegate.selectBoxDidChangeValue === 'function'){
      this.props.delegate.selectBoxDidChangeValue(e);
    }
  }

  render() {
    let options = [];
    if (!this.state.isRequired) {
      options = [
        <option key="none" value="">{I18n.t("service.label_000047")}</option>
      ];
    }
    for (var i = 0; i < this.props.items.length; i++) {
      const item = this.props.items[i];
      options.push(<option key={item.value} value={item.value}>{item.label}</option>);
    }

    return (
      <select name={this.props.name}
        value={this.state.value || ''}
        disabled={this.props.options.disabled}
        onChange={this.didChangeValue.bind(this)}
        className={this.props.options.className}>
        {options}
      </select>
    );
  }
}

SMFormSelectBox.defaultProps = {
  isRequired: true,
  options: {
    className: "",
    disabled: false,
  },
};

export default SMFormSelectBox;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormSelectBox.jsx